import { twMerge } from 'tailwind-merge';
import type { DeltaTone } from '@/types';
import { classes, getToneClasses } from './utils';

export type DeltaPillProps = {
  className?: string;
  tone: DeltaTone;
  label: string;
};

export default function DeltaPill({ className, tone, label }: DeltaPillProps) {
  return (
    <span className={twMerge(classes.pill, getToneClasses(tone), className)}>
      {label}
    </span>
  );
}
